import { X } from 'lucide-react';
import type { ColumnConfig, ColumnId } from '../types';

interface ColumnVisibilityPanelProps {
  columns: ColumnConfig[];
  onToggleVisibility: (columnId: ColumnId) => void;
  onClose: () => void;
}

export default function ColumnVisibilityPanel({
  columns,
  onToggleVisibility,
  onClose,
}: ColumnVisibilityPanelProps) {
  const displayColumns = columns.filter((col) => col.id !== 'select');

  return (
    <div className="fixed right-0 top-0 h-full w-96 glass-panel border-l-2 border-slate-200 dark:border-slate-800 shadow-2xl z-40 flex flex-col transition-colors duration-300">

      {/* Header */}
      <div className="flex-shrink-0 flex items-center justify-between p-4 border-b-2 border-slate-200 dark:border-slate-800">
        <h2 className="text-base font-semibold text-slate-800 dark:text-slate-100">
          Column Visibility
        </h2>
        <button
          onClick={onClose}
          className="p-1.5 rounded-lg hover:bg-red-50 dark:hover:bg-red-900/20 text-slate-400 hover:text-red-500 dark:hover:text-red-400 transition-colors"
          title="Close"
        >
          <X className="w-4 h-4" />
        </button>
      </div>

      {/* Column list */}
      <div className="flex-1 overflow-y-auto p-4 space-y-1">
        {displayColumns.map((col) => (
          <div
            key={col.id}
            className="flex items-center justify-between px-2 py-2.5 rounded-lg hover:bg-slate-50 dark:hover:bg-neutral-800/60 transition-colors"
          >
            <span className="text-sm text-slate-700 dark:text-slate-200">{col.label}</span>

            {/* Pill toggle */}
            <button
              onClick={() => onToggleVisibility(col.id)}
              title={col.visible ? 'Hide column' : 'Show column'}
              className={`relative w-11 h-6 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-green-500 ${
                col.visible
                  ? 'bg-green-500'
                  : 'bg-gray-300 dark:bg-neutral-600'
              }`}
            >
              <div
                className={`absolute top-1 w-4 h-4 bg-white rounded-full shadow-sm transition-all duration-200 ${
                  col.visible ? 'left-6' : 'left-1'
                }`}
              />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
